module.exports = __webpack_public_path__ + "files/fdce7d22e1dcac8d4815a95bcf2a64f7.svg";